$(document).ready(function() {
  // ==================================================
  // icosahedron
  // ==================================================
  const $d = polyhedron;
  const h = function() {
    $(this).toggleClass('hover');
  };
  const ldy = [-150, -90, -30];
  const ldx = -1;

  $d.init('mainvisual_canvas_frontLine');
  $d.addObjectDefinition(additionalObjects);
  $d.setDefaultAngle(-44, -92);
  $d.setColorNumber(1 - 0);
  $d.setLightDirection(ldy[1 - 0], ldx);
  $d.setTransparency((80 - 0) / 100);
  $d.setDrawMode(3 - 0);
  $d.setObject('icosa');
  $d.redraw(true);

  // ==================================================
  // Scroll icosahedron
  // ==================================================
  $(window).on('scroll', function() {
    const $target = $('.js_mainvisualTransparent');
    let $trigger = $('.top_business');
    let offset = 310;
    if (is_mobile()) {
      $trigger = $('.top_about');
      offset = 480;
    }
    const scroll = $(window).scrollTop();
    const h = $(window).height();
    const pos = $trigger.offset().top;
    if (scroll > pos - h + offset) {
      $target.addClass('js_mainvisualTransparent-active');
    } else {
      $target.removeClass('js_mainvisualTransparent-active');
    }
  }).trigger('scroll');
});


$(window).on('load', function() {
  // ==================================================
  // Load Animation
  // ==================================================
  const js_loadAnimationClass = 'js_loadAnimation';
  const js_loadAnimationActiveClass = 'js_loadAnimation-active';
  setTimeout(function(){
    $('.' + js_loadAnimationClass).addClass(js_loadAnimationActiveClass);
  }, 300);
});

// ==================================================
//  Scroll Active or Passive
// ==================================================
function scrollAnimationSet() {
  $('body').addClass('js_scrollAnimationBody');
  $('.js_scrollAnimationTopcontent').removeClass('js_scrollAnimationTopcontent-active');
  setTimeout(function() {
    $('.js_scrollAnimationMainvisual').removeClass('js_scrollAnimationMainvisual-active');
  }, 550);
}

function scrollAnimationActive() {
  $('.js_scrollAnimationMainvisual').addClass('js_scrollAnimationMainvisual-active');
  setTimeout(function() {
    $('.js_scrollAnimationTopcontent').addClass('js_scrollAnimationTopcontent-active');
  }, 550);
  setTimeout(function() {
    $('body').removeClass('js_scrollAnimationBody');
  }, 1500);
}

wheelFlag = false;
// マウスホイールのときの処理
window.onmousewheel = function(e) {
  // console.log('aaa');
  if (!wheelFlag) {
    wheelFlag = true;
    if (e.deltaY > 0) {
      // 下にスクロール
      // console.log(e.deltaY);
      scrollAnimationActive();
    } else if (e.deltaY < 0) {
      // 上にスクロール
      // console.log(e.deltaY);
      if ($(window).scrollTop() <= 0) {
        // scrollAnimationSet();
      }
    }
    setTimeout(function () {
      wheelFlag = false;
    }, 1550);
  }
};

// $(function() {
//   // Scroll
//   $(window).on('scroll', function(e) {
//     e.preventDefault();
//     // console.log('aa');
//     if ($(this).scrollTop() <= 0) {
//       // scrollAnimationSet();
//     }
//   }).trigger('scoll');
// });

// $(window).on('load', function(e) {
//   if ($(window).scrollTop() > 0) {
//     scrollAnimationActive();
//   }
// });